import { all } from 'redux-saga/effects'

import { saga as locationSaga } from './location'
import { saga as authSaga } from './authentication'
import { saga as globalSaga } from './global'
// import { saga as menuNewsSaga } from './menuNews'
export const makeRootSaga = store => {
  return function* rootSaga() {
    yield all([
      ...store.rootSaga,
      ...locationSaga,
      ...authSaga,
      ...globalSaga
      // ...menuNewsSaga
    ])
  }
}

export const injectSaga = (store, { key, saga }) => {
  if (Object.hasOwnProperty.call(store.asyncSagas, key)) return

  store.asyncSagas[key] = saga
  store.rootSaga = [...store.rootSaga, ...saga]
  store.runSaga(makeRootSaga(store))
}

export default makeRootSaga



// WEBPACK FOOTER //
// ./src/store/sagas.js